import Wait from "./Wait"

export default Wait
